import { showError } from 'utils/messages';

import BaseModal from 'app/views/modals/base_modal';

import tmpl from 'templates/one_time_charge_modal';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .cancel': 'close',
    'click .submit_charge': 'submitCharge',
  },

  initialize(options) {
    this.user = options.user;
  },

  context() {
    return {
      chargeableType: this.model.get('object'),
      bankName: this.model.get('bank_name'),
      brand: this.model.get('brand'),
      last4: this.model.get('last4'),
      charge_amounts_dollars: [20, 50, 100, 500, 1000, 2500, 5000, 10000, 15000, 20000],
    };
  },

  getAmount() {
    return this.$('#charge_amount option:selected').val();
  },

  submitCharge(event) {
    event.preventDefault();
    const amount = this.getAmount();

    if (!amount) {
      showError('You must enter the amount to charge.');
    } else {
      this.model.charge(amount, this.user);
    }
    this.close();
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/one_time_charge_modal.js